import { SVGProps } from 'react';

const GitPullRequestClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0v12M21 3l-6 6m6 0-6-6m3 8.5V15m0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
    />
  </svg>
);
export default GitPullRequestClosed;
